import React from 'react';
import Icon from '@pushpay/icon';

const TransactionsIcon = props => {
  return /*#__PURE__*/React.createElement(Icon, Object.assign({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.19 9.505c.1-.001.187.068.207.166a7.506 7.506 0 005.932 5.932c.098.02.167.107.166.207A6.248 6.248 0 118.19 9.505zm-.146 2.755a.625.625 0 00-.625.624v.195a.208.208 0 01-.159.206 1.666 1.666 0 00-.25 3.166l1.606.641a.417.417 0 01-.155.805H6.878a.625.625 0 100 1.25h.333c.115 0 .208.093.208.208v.139a.625.625 0 001.25 0V19.3c0-.096.064-.18.157-.204a1.662 1.662 0 00.25-3.165l-1.604-.642a.417.417 0 01.156-.808H9.21a.625.625 0 000-1.25h-.333a.208.208 0 01-.208-.208v-.139a.625.625 0 00-.625-.624zM15.75 2a6.254 6.254 0 016.248 6.248A6.248 6.248 0 1115.75 2zm-.003 1.489a.625.625 0 00-.625.624v.417a.21.21 0 01-.177.207 1.923 1.923 0 00-.431 3.69l2.004.802a.679.679 0 01-.25 1.31h-1.976a.625.625 0 000 1.25h.625c.115 0 .208.092.208.207v.382c0 .345.28.625.625.625a.625.625 0 00.627-.62v-.417a.21.21 0 01.177-.207 1.923 1.923 0 00.432-3.69l-2.004-.803a.679.679 0 01.25-1.31h1.973a.625.625 0 000-1.249h-.625a.208.208 0 01-.208-.208v-.386a.625.625 0 00-.625-.624z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
};

export default TransactionsIcon;